import React from 'react';

const Loading = ({ className, classSpinner }) => (
  <div
    className={`text-center text-primary h-100 d-flex align-items-center justify-content-center ${className ||
      'loading'}`}
  >
    <div className={`spinner-border ${classSpinner || ''}`} role='status' />
  </div>
);

export default Loading;
